import { Action } from 'redux'
import { Lease, LeaseStatusType } from '../../types/lease'

export const SET_LEASE_LIST = 'SET_LEASE_LIST'
export const SET_LEASE_LOADING = 'SET_LEASE_LOADING'
export const SET_LEASE_ERROR = 'SET_LEASE_ERROR'
export const SET_SELECTED_LEASE = 'SET_SELECTED_LEASE'
export const SET_SELECTED_STATUS = 'SET_SELECTED_STATUS'

interface SetLeaseListAction extends Action {
    type: typeof SET_LEASE_LIST
    leaseList: Lease[] | null
}

interface SetLeaseLoadingAction extends Action {
    type: typeof SET_LEASE_LOADING
    loading: boolean
}

interface SetLeaseErrorAction extends Action {
    type: typeof SET_LEASE_ERROR
    error: string | null
}

interface SetSelectedLeaseAction extends Action {
    type: typeof SET_SELECTED_LEASE
    selectedLease?: Lease | null
}

interface SetSelectedStatusAction extends Action {
    type: typeof SET_SELECTED_STATUS
    selectedStatus: LeaseStatusType | null
}

export type LeaseActionTypes = 
    | SetLeaseListAction 
    | SetLeaseLoadingAction 
    | SetLeaseErrorAction 
    | SetSelectedLeaseAction
    | SetSelectedStatusAction 